<template>
  <div class="content-container">
    <search-comp @onSearch="onSearch" @onReset="onResetSearch">
      <div class="das-form-container">
        <div class="das-form-group">
          <div class="das-form-row">
            <div class="das-form-col col-3">
              <div class="das-form-input">
                <div class="label">
                  {{ 'Mã chương trình' }}
                </div>
                <div class="">
                  <input type="text" placeholder="selectwithsearch" />
                </div>
              </div>
            </div>
            <div class="das-form-col col-3">
              <div class="das-form-input">
                <div class="label">
                  {{ 'Tên chương trình' }}
                </div>
                <div class="">
                  <input type="text" placeholder="selectwithsearch" />
                </div>
              </div>
            </div>
            <div class="das-form-col col-3">
              <div class="das-form-input">
                <div class="label">
                  {{ 'Khoảng ngày' }}
                </div>
                <div class="">
                  <CalendarRange v-model="date" mode="date" />
                </div>
              </div>
            </div>
            <div class="das-form-col col-3">
              <div class="das-form-input">
                <div class="label">
                  {{ 'Người sử dụng' }}
                </div>
                <div class="">
                  <input type="text" placeholder="selectwithsearch" />
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </search-comp>

    <div class="content-box">
      <div class="section-box outline">
        <div class="das-form-container">
          <div class="das-form-title-container" style="display: flex">
            <div class="das-form-title">
              <span class="main-title">
                {{ `Báo cáo doanh thu theo chương trình` }}
              </span>
            </div>

            <DownloadBtn @openNoteDialog="dialogNoteVisible = true" />
          </div>
          <hr />

          <div class="grid-scroll mt-10">
            <GridVx
              ref="agGrid"
              :columns="columns"
              :rows="rows"
              class="agGrid"
            />
          </div>
        </div>
      </div>
    </div>

    <NoteDialog v-model="dialogNoteVisible">
      <div class="das-form-container">
        <div class="das-form-group">
          <ul class="annotate-container">
            <li>- Mã chương trình: Hiển thị Mã chương trình được sử dụng</li>
            <li>- Tên chương trình: hiển thị tên chương trình được sử dụng</li>
            <li>
              - Thời gian áp dụng: Hiển thị thời gian áp dụng của chương trình
              dưới dạng Từ ngày - Đến ngày: Format: DDMMYYYY- DDMMYYYY
            </li>
            <li>- Mã đặt phòng: Hiển thị mã đặt phòng áp dụng chương trình</li>
            <li>
              - Doanh thu: Hiển thị Doanh thu tổng các dịch vụ sử dụng thỏa mãn
              điều kiện
            </li>
            <li>
              - Giảm giá: Số tiền giá trị phần quà được tặng kèm hoặc số tiền
              được giảm giá theo cấu hình cho chương trình
            </li>
            <li>- Thành tiền: Doanh thu - Giảm giá</li>
            <li>
              - Người sử dụng : hiển thị họ và tên người sử dụng thêm chương
              trình cho khách
            </li>
            <li>- Tổng: Hiển thị tổng của các cột thông tin về tiền</li>
          </ul>
        </div>
      </div>
    </NoteDialog>
  </div>
</template>

<script>
import DownloadBtn from '../components/DownloadBtn.vue'
import NoteDialog from '../components/NoteDialog.vue'
import CalendarRange from '@/components/CalendarSelect/CalendarRange.vue'

export default {
  components: { DownloadBtn, NoteDialog, CalendarRange },
  data() {
    return {
      // date
      date: {
        start: null,
        end: null
      },

      // grid
      columns: [
        { headerName: 'Mã chương trình', field: '' },
        { headerName: 'Tên chương trình', field: '' },
        { headerName: 'Thời gian áp dụng', field: '' },
        { headerName: 'Thời gian sử dụng', field: '' },
        { headerName: 'Điều kiện sử dụng', field: '' },
        { headerName: 'Mã đặt phòng', field: '' },
        { headerName: 'Doanh thu', field: '' },
        { headerName: 'Giảm giá', field: '' },
        { headerName: 'Thành tiền', field: '' },
        { headerName: 'Người sử dụng', field: '' }
      ],
      rows: [],

      // dialog
      dialogNoteVisible: false
    }
  },
  methods: {
    onSearch() {},
    onResetSearch() {}
  }
}
</script>
